import n from "axios";
const O = async ({
  postalCode: a,
  isIO: p,
  selectedItem: r
}) => {
  try {
    if (p) {
      const { data: o } = await n.get(
        `/_v/commerce/products/productsSimilar?postalCode=${a}&skus=${r == null ? void 0 : r.productOriginId}&field=sku`
      ), { similarProducts: u } = o;
      return u.find(
        (c) => c.productOrigin === (r == null ? void 0 : r.productOriginId)
      );
    }
    const { data: i } = await n.post("/api/proxy", {
      targetUrl: `/_v/commerce/products/productsSimilar?postalCode=${a}&skus=${r == null ? void 0 : r.productOriginId}&field=sku`,
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json"
      }
    }), { similarProducts: s } = i;
    return s.find(
      (o) => o.productOrigin === r.productOriginId
    );
  } catch (i) {
    console.error("Error in Change Order Modal", i);
  }
};
export {
  O as getProductsSimilars
};
